export default "__VITE_ASSET__DKEK3H9k__"